import React from 'react';
import {Modal, Descriptions} from 'antd';
import ImagePictureCard from '@/components/ImagePictureCard';
import moment from 'moment'
import Common from '../../components/commonTable/commonShowComponent';
import styles from './index.less';

const EvaluationResult = ({
  onCancel,
  result = {},
  type = 'default'
}) => {
  const modalProps = {
    title: '评估报告',
    footer: null,
    visible: true,
    onCancel,
    className: styles['evaluation-result-modal'],
    width: 800
  };

  return (
    <Modal {...modalProps}>
      {type === 'default'?
      <div className='result-summary'>
        <div className='summary-label-medal'>心理问题（心理困扰&心理疾病）</div>
        <div className='summary-content'>
          <Descriptions column={1}>
            <Descriptions.Item label='问题类型'>{result.problemType}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label-medal'>专科检测</div>
        <div className='summary-label'>心理量表</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='SCL-90'>{result.scl90TestResultSummary}</Descriptions.Item>
            <Descriptions.Item label='抑郁自评量表'>{result.sdsTestResultSummary}</Descriptions.Item>
            <Descriptions.Item label='焦虑自评量表'>{result.sasTestResultSummary}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>测评分析</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='脑健康测评'>{result.brainHealthAssessmentSummarize}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label-medal'>BPS评估诊断</div>
        <div className='summary-label'>生理</div>
        <div className='summary-content'>
          <Descriptions column={1}>
            <Descriptions.Item label='临床症状'>{result.clinicalSymptom}</Descriptions.Item>
            <Descriptions.Item label='概念化总结'>{result.biologicalConceptualization}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>心理</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='原生家庭'>{result.originalFamily}</Descriptions.Item>
            <Descriptions.Item label='人格'>{result.personality}</Descriptions.Item>
          </Descriptions>
          <Descriptions column={1}>
            <Descriptions.Item label='概念化总结'>{result.psychologicalConceptualization}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>社会</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='个人生活'>{result.personalLife}</Descriptions.Item>
            <Descriptions.Item label='社会功能'>{result.socialFunction}</Descriptions.Item>
          </Descriptions>
          <Descriptions column={1}>
            <Descriptions.Item label='概念化总结'>{result.socialConceptualization}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
      :<Common result={result}/>}
    </Modal>
  );
};

export default EvaluationResult;
